import React from 'react';
import { connect } from 'react-redux';

import { changeLearnMoreModalVisibility } from '../actions';
import MembershipLearnMoreModal from '../components/MembershipLearnMoreModal';

const mapStateToProps = state => ({
  isOpen: state.learnMoreIsOpen,
  subscribableVariantDiscountRate: state.subscribableVariantDiscountRate,
  subscribableVariantFreeFrequency: state.subscribableVariantFreeFrequency,
});

const mapDispatchToProps = dispatch => ({
  close: () => {
    dispatch(changeLearnMoreModalVisibility(false));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(
  MembershipLearnMoreModal
);



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/containers/MembershipLearnMoreModal.js